import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import cartReducer from "./cartSlice";
import ordersReducer from "./ordersSlice";

// 1️⃣ Persist Config
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["cart", "orders"], // only these slices will be persisted
};

// 2️⃣ Combine reducers
const rootReducer = combineReducers({
  cart: cartReducer,
  orders: ordersReducer,
});

// 3️⃣ Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// 4️⃣ Configure store
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // required for redux-persist
    }),
});

export const persistor = persistStore(store);
export default store;
